var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.statusConfig.color,"text-color":_vm.statusConfig.color ? 'white' : ''}},[_vm._v(" "+_vm._s(_vm.statusConfig.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }